export default "__VITE_ASSET__CJit6ZUz__"